/* istanbul ignore file */
import { array as codecArray, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { JsonPatchSubmitTypesAssignment } from './JsonPatchSubmitTypesAssignment';
const PatchSubmitTypesAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['json', JsonPatchSubmitTypesAssignment],
    [
        'template',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(parsers.file)),
    ],
]);
export class PatchSubmitTypesAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSubmitTypesAssignmentDataParser.decode(input).map(res => new PatchSubmitTypesAssignmentData(res));
    }
    static unsafeDecode(input) {
        return PatchSubmitTypesAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSubmitTypesAssignmentDataParser.encode(data);
    }
    static schema() {
        return PatchSubmitTypesAssignmentDataParser.schema();
    }
}
